import React from 'react';
import { Button } from '@fluentui/react-components';
import { useStyles } from './OutlookHome.styles';

interface OutlookTestButtonsProps {
    onAuthenticate: () => Promise<void>;
    onPing: () => Promise<void>;
    onCheckCase: () => Promise<void>;
}

export const OutlookTestButtons: React.FC<OutlookTestButtonsProps> = ({ onAuthenticate, onPing, onCheckCase }) => {
    const styles = useStyles();
    const [isVisible] = React.useState(() => localStorage.getItem('testAuth') === 'true');

    if (!isVisible) return null;

    return (
        <div className={styles.buttonContainer}>
            <Button appearance="primary" onClick={() => void onAuthenticate()}>Authenticate to 360</Button>
            <Button appearance="primary" onClick={() => void onPing()}>Test Ping</Button>
            <Button appearance="primary" onClick={() => void onCheckCase()}>Check Case</Button>
        </div>
    );
};